/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import React from "react";
import styled from "@mui/styled-engine-sc";
import DialogContentText from "@mui/material/DialogContentText";

const StyledDialogContentText = styled(({ ...props }) => <DialogContentText {...props} />)`
  && {
  }
`;

export { StyledDialogContentText };
